module.exports = function() {
  return new Worker(__webpack_public_path__ + "efb4685aff28a103ba18.worker.js");
};